import apiEndpoints from '../../../api';
import { clean, url, listParams, bodyOf, getReq, writeReq } from './vmsHttp';

export const getVisitsListReq = (action) => {
    const d = action.data;
    return getReq(apiEndpoints.SOCIETY_GET_VISITS_LIST_API, listParams(d, {
        status: d?.status,
        flat_id: d?.flatId,
        visitor_id: d?.visitorId,
        from_date: d?.fromDate,
        to_date: d?.toDate,
    }), 'Failed to load visits');
};

// The detail endpoint returns the full visitor object plus flat, wing,
// preApproval and gatePass — heavier than a list row, so only the detail screen
// asks for it.
export const getVisitDetailsReq = (action) =>
    getReq(url(apiEndpoints.SOCIETY_GET_VISIT_DETAILS_API, { id: action.data.id }), undefined, 'Failed to load visit');

// The server decides the initial status from the visitor's block flag, a
// matching pre-approval, a matching gate pass and the society's gate entry
// mode — so the caller must read data.status back rather than assume PENDING.
export const createVisitReq = (action) =>
    writeReq('post', apiEndpoints.SOCIETY_CREATE_VISIT_API, clean(bodyOf(action.data)),
        'Visit logged', 'Failed to log visit');

export const updateVisitReq = (action) =>
    writeReq('put', url(apiEndpoints.SOCIETY_UPDATE_VISIT_API, { id: action.data.id }),
        bodyOf(action.data), 'Visit updated', 'Failed to update visit');

// Soft delete that also forces status to CANCELLED, from any status.
export const deleteVisitReq = (action) =>
    writeReq('delete', url(apiEndpoints.SOCIETY_DELETE_VISIT_API, { id: action.data.id }),
        undefined, 'Visit cancelled', 'Failed to cancel visit');

export const approveVisitReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_APPROVE_VISIT_API, { id: action.data.id }), {},
        'Visit approved', 'Failed to approve visit');

export const rejectVisitReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_REJECT_VISIT_API, { id: action.data.id }),
        clean(bodyOf(action.data)), 'Visit rejected', 'Failed to reject visit');

// No attempt counter server-side, so a wrong code just comes back 400 and the
// operator can retry until otp_expires_at passes.
export const verifyVisitOtpReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_VERIFY_VISIT_OTP_API, { id: action.data.id }),
        { otp: action.data.otp }, 'OTP verified', 'OTP verification failed');

export const checkInVisitReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_CHECK_IN_VISIT_API, { id: action.data.id }),
        clean(bodyOf(action.data)), 'Visitor checked in', 'Failed to check in');

export const checkOutVisitReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_CHECK_OUT_VISIT_API, { id: action.data.id }),
        clean(bodyOf(action.data)), 'Visitor checked out', 'Failed to check out');
